import { toast, Toaster } from 'sonner';
import { ToastBody } from './_ToastBody';
import { onPositionNative } from './_toastPosition';

/*
    🔥 TOAST — sonner

    Usa toast.custom para renderizar NUESTRO cuerpo. Así respeta las
    8 variantes y los tokens, no la paleta de sonner.
*/

export const AlertSonnerHost = ({ position }) => (
    <Toaster position={onPositionNative(position)} expand
        toastOptions={{ unstyled: true, classNames: { toast: 'LStudio__app_toast_wrap' } }} />
);

export const onNotifySonner = ({ type = 'info', title, text, autoClose }) => (

    toast.custom(
        (id) => <ToastBody type={type} title={title} text={text} onClose={() => toast.dismiss(id)} />,
        { duration: autoClose || 4000 },
    )
);
